import { GET_SECTIONS_FOR_IRN } from "./actionTypes";

// eslint-disable-next-line 
export default (state = [], action) => {
   switch(action.type) {
      case GET_SECTIONS_FOR_IRN:
         return action.payload;
      default:
         return state;
   };
 };